<app-document-operator-dashboard #theDashboard [parameters]="parameters"></app-document-operator-dashboard>
